export const initialState = {
    opened: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_MENU':
            return {
                ...state,
                opened: action.opened,
            };
        default:
            return state;
    }
};
